import React from 'react';

const DataProviderIcon = ({
  style = {},
  fill = '#3a84a8',
  width = '100%',
  className = '',
  height = '100%',
  viewBox = '0 0 1024 1024',
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fill={fill}
      d="M438.857 438.857q135.429 0 253.143-24.571t185.714-72.571v97.143q0 39.429-58.857 73.143t-160 53.429-220 19.714-220-19.714-160-53.429-58.857-73.143v-97.143q68 48 185.714 72.571t253.143 24.571zM438.857 877.714q135.429 0 253.143-24.571t185.714-72.571v97.143q0 39.429-58.857 73.143t-160 53.429-220 19.714-220-19.714-160-53.429-58.857-73.143v-97.143q68 48 185.714 72.571t253.143 24.571zM438.857 658.286q135.429 0 253.143-24.571t185.714-72.571v97.143q0 39.429-58.857 73.143t-160 53.429-220 19.714-220-19.714-160-53.429-58.857-73.143v-97.143q68 48 185.714 72.571t253.143 24.571zM438.857 0q118.857 0 220 19.714t160 53.429 58.857 73.143v73.143q0 39.429-58.857 73.143t-160 53.429-220 19.714-220-19.714-160-53.429-58.857-73.143v-73.143q0-39.429 58.857-73.143t160-53.429 220-19.714z"
    />
  </svg>
);

export default DataProviderIcon;
